namespace Matrix.Data {
    export interface SecurityMatchRuleRow {
        RuleCode?: string;
        Description?: string;
        CommandText?: string;
        RowId?: number;
        Version?: number;
        CreatedBy?: string;
        CreatedWhen?: string;
        UpdatedBy?: string;
        UpdatedWhen?: string;
    }

    export namespace SecurityMatchRuleRow {
        export const idProperty = 'RuleCode';
        export const nameProperty = 'Description';
        export const localTextPrefix = 'Data.SecurityMatchRule';
        export const lookupKey = 'Data.SecurityMatchRule';

        export function getLookup(): Q.Lookup<SecurityMatchRuleRow> {
            return Q.getLookup<SecurityMatchRuleRow>('Data.SecurityMatchRule');
        }
        export const deletePermission = 'DataAdmin:SecurityMatchRule';
        export const insertPermission = 'DataAdmin:SecurityMatchRule';
        export const readPermission = 'Read:SecurityMatchRule';
        export const updatePermission = 'DataAdmin:SecurityMatchRule';

        export declare const enum Fields {
            RuleCode = "RuleCode",
            Description = "Description",
            CommandText = "CommandText",
            RowId = "RowId",
            Version = "Version",
            CreatedBy = "CreatedBy",
            CreatedWhen = "CreatedWhen",
            UpdatedBy = "UpdatedBy",
            UpdatedWhen = "UpdatedWhen"
        }
    }
}
